module.exports = __webpack_public_path__ + "img/uber.01ca319a.svg";